// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"aae3ee9c","885":"0bb12c82"}[chunkId] + ".css";
};